// import { db } from '@/db';
import api from '@/api/survey';
import { db } from '@/db';

const state = {
  submitting: false,
  error: null,
  eventData: null,
  surveys: [],
  statistics: {
    north: {
      total: 0,
      returned: 0,
      percentage: 0,
    },
    central: {
      total: 0,
      returned: 0,
      percentage: 0,
    },
    south: {
      total: 0,
      returned: 0,
      percentage: 0,
    },
    trend: {
      total: [],
      returned: [],
      percentage: [],
    },
  },
};

const mutations = {
  SET_SUBMITTING(state, value) {
    state.submitting = value;
  },
  SET_ERROR(state, error) {
    state.error = error;
  },
  SET_STATISTICS(state, data) {
    state.statistics = data;
  },
  SET_EVENT_DATA(state, data) {
    state.eventData = data;
  },
  SET_SURVEYS(state, data) {
    state.surveys = data;
  },
};

const actions = {
  async getStatistics({ commit }, { date }) {
    try {
      const { data } = await api.getStatistics(date);
      commit('SET_STATISTICS', data);
      return data;
    } catch (error) {
      commit('SET_ERROR', '獲取統計數據失敗');
      throw error;
    }
  },
  async submitSurvey({ commit }, surveyData) {
    console.log('开始提交问卷数据:', surveyData);
    commit('SET_SUBMITTING', true);
    try {
      const response = await api.submitSurvey(surveyData);
      console.log('提交问卷API响应:', response);
      const { data } = response;
      console.log('提交问卷返回数据:', data);
      commit('SET_SUBMITTING', false);
      return data;
    } catch (error) {
      console.error('提交问卷失败:', error);
      console.error('错误详情:', error.response || error.message);
      commit('SET_ERROR', '提交問卷失敗');
      commit('SET_SUBMITTING', false);
      throw error;
    }
  },
  async getEventById({ commit }, id) {
    console.log('开始获取事件数据，ID:', id);
    try {
      const response = await api.getEventById(id);
      console.log('API原始响应:', response);
      const { data } = response;
      console.log('API返回的数据:', data);
      if (data && data.events && data.events.length > 0) {
        const eventData = data.events[0];
        console.log('提取的第一个事件:', eventData);
        commit('SET_EVENT_DATA', eventData);
        return eventData;
      }
      console.warn('未找到事件数据，API返回的events为空');
      throw new Error('未找到事件數據');
    } catch (error) {
      console.error('获取事件数据失败:', error);
      console.error('错误详情:', error.response || error.message);
      commit('SET_ERROR', '獲取事件數據失敗');
      throw error;
    }
  },
  async getDefaultValues({ commit, dispatch }, { orderId }) {
    commit('SET_SUBMITTING', true);
    console.log('开始获取默认值，单据ID:', orderId);
    try {
      // 确保orderId有效
      if (!orderId) {
        throw new Error('未提供维修单ID');
      }
      // 尝试获取事件数据
      console.log('正在调用getEventById获取事件数据...');
      const eventData = await dispatch('getEventById', orderId);
      console.log('获取到的事件数据:', JSON.stringify(eventData, null, 2));
      // 检查事件数据中的关键字段
      if (!eventData.clientName && !eventData.clientTel) {
        console.warn('获取到的事件数据中缺少客户信息字段');
        // 打印可用字段清单
        console.log('可用字段清单:', Object.keys(eventData).join(', '));
      }
      // 尝试从不同来源获取技术人员信息
      let technicianName = '';
      if (Array.isArray(eventData.memberList) && eventData.memberList.length > 0) {
        technicianName = eventData.memberList.join('、');
        console.log('从memberList获取到技术人员:', technicianName);
      } else if (eventData.technicianName) {
        technicianName = eventData.technicianName;
        console.log('从technicianName获取到技术人员:', technicianName);
      } else if (eventData.member) {
        technicianName = Array.isArray(eventData.member) ? eventData.member.join('、') : eventData.member;
        console.log('从member获取到技术人员:', technicianName);
      } else {
        console.warn('无法在事件数据中找到技术人员信息');
      }
      // 尝试从不同来源获取客户名称
      const customerName = eventData.clientName || eventData.customerName || eventData.customer || '';
      // 尝试从不同来源获取客户电话
      const phone = eventData.clientTel || eventData.customerPhone || eventData.phone || '';
      // 尝试从不同来源获取区域
      const area = eventData.region || eventData.area || '';
      // 映射字段
      const defaultValues = {
        customerName,
        phone,
        technicianName,
        area,
      };
      console.log('处理后的默认值:', defaultValues);
      commit('SET_SUBMITTING', false);
      return defaultValues;
    } catch (error) {
      console.error('获取默认值失败:', error);
      console.error('错误堆栈:', error.stack);
      const errorMessage = error.response
        ? `获取数据失败: ${error.response.status} - ${error.response.data?.message || '未知错误'}`
        : `获取数据失败: ${error.message || '网络错误或服务器无响应'}`;
      console.warn('错误详情:', errorMessage);
      commit('SET_ERROR', errorMessage);
      commit('SET_SUBMITTING', false);
      // 返回空值和错误信息
      const emptyValues = {
        customerName: '',
        phone: '',
        technicianName: '',
        area: '',
        error: errorMessage,
      };
      console.log('返回的空值:', emptyValues);
      return emptyValues;
    }
  },
  async getSurveys({ commit }) {
    try {
      console.log('开始从Firestore获取问卷数据');
      // 修正: 使用正确的集合路径 - companies/hsH43NOpBi9XSG3YeU1g/surveys
      const surveysSnapshot = await db.collection('companies').doc('hsH43NOpBi9XSG3YeU1g').collection('surveys').get();
      console.log('Firestore查询结果:', surveysSnapshot);

      if (surveysSnapshot.empty) {
        console.log('Firestore中没有找到surveys集合数据');
        commit('SET_SURVEYS', []);
        return [];
      }

      // 转换Firestore文档为数组
      const surveyData = [];
      surveysSnapshot.forEach((doc) => {
        console.log('文档ID:', doc.id, '文档数据:', doc.data());
        surveyData.push({
          id: doc.id,
          ...doc.data(),
        });
      });

      console.log('从Firestore获取的问卷数据:', surveyData);

      if (surveyData.length > 0) {
        console.log('问卷数据的第一条记录样例:', surveyData[0]);
        commit('SET_SURVEYS', surveyData);
        return surveyData;
      }

      console.warn('未找到有效的问卷数据');
      commit('SET_SURVEYS', []);
      return [];
    } catch (error) {
      console.error('获取问卷列表失败:', error);
      console.error('错误详情:', error.message);
      commit('SET_ERROR', '獲取問卷列表失敗');
      return [];
    }
  },
  async deleteSurvey({ commit, dispatch }, id) {
    try {
      await api.deleteSurvey(id);
      // 刷新问卷列表
      await dispatch('getSurveys');
      return true;
    } catch (error) {
      commit('SET_ERROR', '刪除問卷失敗');
      throw error;
    }
  },
  async getSurveyByOrderId({ commit }, orderId) {
    console.log('根据维修单ID查询已提交问卷:', orderId);
    try {
      if (!orderId) {
        console.warn('未提供维修单ID，无法查询问卷');
        return null;
      }
      // 查询该维修单ID对应的问卷数据
      const surveysRef = db.collection('companies').doc('hsH43NOpBi9XSG3YeU1g').collection('surveys');
      const snapshot = await surveysRef.where('orderId', '==', orderId).get();
      if (snapshot.empty) {
        console.log('未找到该维修单ID对应的问卷数据');
        return null;
      }
      // 通常只会有一个问卷与维修单ID对应
      let surveyData = null;
      snapshot.forEach((doc) => {
        surveyData = {
          id: doc.id,
          ...doc.data(),
        };
      });
      console.log('找到的问卷数据:', surveyData);
      return surveyData;
    } catch (error) {
      console.error('查询问卷数据失败:', error);
      commit('SET_ERROR', '獲取問卷數據失敗');
      return null;
    }
  },
};

const getters = {
  isSubmitting: (state) => state.submitting,
  error: (state) => state.error,
  getStatistics: (state) => state.statistics,
  getEventData: (state) => state.eventData,
  getSurveyList: (state) => state.surveys,
};

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
};
